import { billingRequest } from "./billing-client";

export interface PaymentDto {
  id: string;
  amount: string;
  paymentMode: string;
  reference: string | null;
  paidAt: string;
  notes: string | null;
  invoice: { id: string; number: string; currency: string };
  customer: { id: string; code: string; displayName: string };
}

export const paymentsApi = {
  list: (params?: { page?: number; limit?: number }) => {
    const q = new URLSearchParams();
    if (params?.page) q.set("page", String(params.page));
    if (params?.limit) q.set("limit", String(params.limit));
    const query = q.toString();
    return billingRequest<{ items: PaymentDto[]; meta: { total: number } }>(
      `/payments${query ? `?${query}` : ""}`,
    );
  },
};
